/* Imperial Time final page motion — 04 Oct 2026. */
(function(){
  'use strict';
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce)return;
  document.documentElement.classList.add('it-final-motion');

  function observeOnce(nodes,extraClass){
    if(!nodes||!nodes.length)return;
    if(!('IntersectionObserver' in window)){
      nodes.forEach(function(el){el.classList.add('it-motion-in');if(extraClass)el.classList.add(extraClass);});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        entry.target.classList.add('it-motion-in');
        if(extraClass)entry.target.classList.add(extraClass);
        io.unobserve(entry.target);
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    nodes.forEach(function(el){
      if(el.dataset.itFinalMotion==='1')return;
      el.dataset.itFinalMotion='1';
      el.classList.add('it-motion-target');
      io.observe(el);
    });
  }

  function initHome(root){
    if(!document.body.classList.contains('page-index'))return;
    var scope=root||document;
    observeOnce([].slice.call(scope.querySelectorAll('.itop-sec:not(.itop-hero),.ithome-lower__module')));
    observeOnce([].slice.call(scope.querySelectorAll('.it-stitch-engagement-step,.ithome-lower__process li')));
  }

  function initProduct(root){
    if(!document.body.classList.contains('page-product'))return;
    var scope=root||document;
    var mobile=window.matchMedia('(max-width: 989px)').matches;
    if(mobile){
      observeOnce([].slice.call(scope.querySelectorAll(
        '.imperial-watch-pdp .imperial-watch-section,'+
        '.imperial-watch-pdp .imperial-watch-kensington,'+
        '.it-jewellery-pdp .it-jewellery-details,'+
        '.it-jewellery-confidence-suite > section,'+
        '.it-jewellery-faq,'+
        '.it-client-reviews,'+
        '.it-cut-section,'+
        '.it-cut-bespoke,'+
        '.it-cut-service-grid,'+
        '.it-mineral-section,'+
        '.it-mineral-service-grid,'+
        '.it-mineral-kensington'
      )));
    }
    var why=scope.querySelectorAll('.it-jewellery-why');
    if(why.length)observeOnce([].slice.call(why),'is-in-view');
  }

  function init(root){initHome(root);initProduct(root);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();